var React = require('react');

function Document12 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 3L3 0H8C9.10457 0 10 0.895431 10 2V12C10 13.1046 9.10457 14 8 14H2C0.89543 14 0 13.1046 0 12V3Z","fill":"#D4D3D0","key":0}),React.createElement("path",{"d":"M10 9V12C10 13.1046 9.10457 14 8 14H5L10 9Z","fill":"#929088","key":1})]);
}

Document12.defaultProps = {"width":"10","height":"14","viewBox":"0 0 10 14","fill":"none"};

module.exports = Document12;

Document12.default = Document12;
